import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { environment } from '@environments/environment';
import { IState } from '@state/state.module';
import { AuthService } from '@shared/services/auth/auth.service';
import '@invitedesk/admin-widgets/support-chat/ivd-support-chat-widget.js';

@Component({
    selector: 'app-support-chat',
    templateUrl: './support-chat.component.html',
    styleUrls: ['./support-chat.component.scss']
})
export class SupportChatComponent {
  public readonly application = 'InviteDesk';
  public readonly host = environment.dashboardApi.baseUrl;

  constructor(private store: Store<IState>, private authService: AuthService) {}

  /** Read on each change detection so a refreshed token is picked up before the ticket is posted. */
  public get token(): string {
    return this.authService.retrieveToken()?.encoded;
  }

  language$ = this.store.select(x => x.app).pipe(map(profile => profile.profile.languageId));
}
